import type { AsyncDataOptions } from '#app'

export function useAppAsyncData<DataT>(
  key: string,
  handler: () => Promise<DataT>,
  options?: AsyncDataOptions<DataT>,
) {
  const localError = ref<Error | null>(null)

  const asyncData = useAsyncData(
    key,
    async () => {
      try {
        localError.value = null
        const result = await handler()
        // undefined не сериализуется в payload → на клиенте снова pending=true
        return (result === undefined ? true : result) as DataT
      } catch (error) {
        localError.value =
          error instanceof Error ? error : new Error(String(error))
        console.warn(`Ошибка загрузки данных (${key}):`, localError.value)
        return null as unknown as DataT
      }
    },
    {
      // Всегда SSR: иначе в dev пустой HTML, на клиенте данные → hydration mismatch
      server: true,
      lazy: import.meta.client,
      ...options,
    },
  )

  return {
    ...asyncData,
    error: localError,
  }
}
